const addTabToStorage = () => {
  // this adds a random number to identify a tab being opened in the browser.

  // set random number for tab
  const tabNumber = Math.floor(Math.random() * 100000);

  // add tab number to session storage
  // session storage is unique to each tab
  // check if one exists first to not overwrite on page reload
  if (!global.sessionStorage.getItem('maisonetteSessionTab')) {
    global.sessionStorage.setItem('maisonetteSessionTab', tabNumber);
  }

  // grab other tabs from local storage
  const tabs = JSON.parse(global.localStorage.getItem('maisonetteTabs')) ?? [];
  // grab tab from session storage
  const sessionTabNumber = global.sessionStorage.getItem('maisonetteSessionTab');
  // add session tab to local storage if it isn't already there
  if (!tabs.includes(sessionTabNumber)) {
    tabs.push(sessionTabNumber);
  }
  // set all tabs to local storage
  global.localStorage.setItem('maisonetteTabs', JSON.stringify(tabs));
};

const removeTabFromStorage = () => {
  // if there is a session tab number for the tab, remove it from local storage
  // happens when tab is closed
  const sessionTabNumber = global.sessionStorage.getItem('maisonetteSessionTab');
  if (sessionTabNumber) {
    const tabs = JSON.parse(global.localStorage.getItem('maisonetteTabs')) ?? [];
    const withTabRemoved = tabs.filter((tab) => tab !== sessionTabNumber);
    global.localStorage.setItem('maisonetteTabs', JSON.stringify(withTabRemoved ?? []));
  }
};

const setTabTitle = (title) => {
  // update title
  global.document.title = title;
};

export {
  addTabToStorage,
  removeTabFromStorage,
  setTabTitle
};
